import React from "react";
import { Button, Tooltip } from "antd";
import { RiAddLine, RiRefreshLine, RiSubtractLine } from "react-icons/ri";

// Below fit one decimal would read 0.0x.
const formatZoom = (zoom) => `${zoom.toFixed(zoom >= 1 ? 1 : 2)}x`;

/**
 * Zoom readout + 縮小 / 放大 / 重置檢視, in a zoomable canvas's top-left
 * corner (CanvasRail side="left" places it). Shared by the live canvas and the
 * plan editor; all state comes from useViewTransform through props. Tooltips
 * open downwards so they never cover the card title and its 場外 status.
 */
const ZoomControls = ({
  zoom,
  isTransformed,
  atMinZoom,
  atMaxZoom,
  onZoomStep,
  onReset,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      padding: "2px 4px",
      borderRadius: 4,
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
      fontSize: 12,
      fontVariantNumeric: "tabular-nums",
      color: isTransformed ? "#1890ff" : "#8c8c8c",
      // The wrapper must not swallow the wheel/drag gestures aimed at
      // the canvas underneath it, so only the button takes pointers.
      pointerEvents: "none",
    }}
  >
    <Tooltip title="縮小" placement="bottom">
      <Button
        type="text"
        size="small"
        icon={<RiSubtractLine />}
        aria-label="縮小"
        disabled={atMinZoom}
        onClick={(e) => {
          e.stopPropagation();
          onZoomStep(-1);
        }}
        style={{ pointerEvents: "auto" }}
      />
    </Tooltip>
    <span style={{ minWidth: 30, textAlign: "center" }}>
      {formatZoom(zoom)}
    </span>
    <Tooltip title="放大" placement="bottom">
      <Button
        type="text"
        size="small"
        icon={<RiAddLine />}
        aria-label="放大"
        disabled={atMaxZoom}
        onClick={(e) => {
          e.stopPropagation();
          onZoomStep(1);
        }}
        style={{ pointerEvents: "auto" }}
      />
    </Tooltip>
    <Tooltip title="重置檢視" placement="bottom">
      <Button
        type="text"
        size="small"
        icon={<RiRefreshLine />}
        aria-label="重置檢視"
        disabled={!isTransformed}
        onClick={(e) => {
          e.stopPropagation();
          onReset();
        }}
        style={{ pointerEvents: "auto" }}
      />
    </Tooltip>
  </div>
);

export default ZoomControls;
